import React, {useState, useRef, useCallback, useEffect} from 'react';
import Vimeo from '@u-wave/react-vimeo';
import { useLessonPlaybackState } from './useLessonPlaybackState';

function useVideoPlayback(videoSrc, activityId) {
    const videoRef = useRef(null);
    const { state, play, pause, reset, setPlayer, finished } = useLessonPlaybackState();

    const handleReady = useCallback(() => {
        setPlayer('vimeo');
        play(activityId);
    }, [state, activityId, play]);

    const handlePlay = useCallback(() => {
        if (state !== 'playing') {
            play(activityId);
        }
    }, [state, activityId, play]);

    const handlePause = useCallback(() => {
        if (state === 'playing') {
            pause(activityId);
        }
    }, [state, activityId, pause]);

    const handleEnd = useCallback(() => {
        finished();
    }, [activityId, reset]);

    const togglePlayback = useCallback(() => {
        if (state === 'playing') {
            pause(activityId);
        } else {
            play(activityId);
        }
    }, [state, activityId, play, pause]);

    const resetVideo = useCallback(() => {
        //TODO implement reset with VIMEO
    }, [activityId, reset]);

    return {
        videoRef,
        state,
        togglePlayback,
        resetVideo,
        vimeoBuilder: useCallback(
            (props) => (
                <Vimeo
                    {...props}
                    ref={videoRef}
                    video={videoSrc}
                    paused={state !== 'playing'}
                    onReady={handleReady}
                    onPlay={handlePlay}
                    onPause={handlePause}
                    onEnd={handleEnd}
                />
            ),
            [videoSrc, state, handleReady, handlePlay, handlePause, handleEnd]
        ),
        cleanup: useCallback(() => {
            console.log(`Video Playback cleanup`);
            setPlayer('audio');
        }, [setPlayer]),
    };
}

export default useVideoPlayback;